import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    body: "Inter, 'Segoe UI', Helvetica, sans-serif",
    heading: "Inter, 'Segoe UI', Helvetica, sans-serif",
  },
  colors: {
    brand: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9", // Primary brand color
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6", // Primary teal color
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
        borderRadius: "md",
      },
      variants: {
        solid: {
          bg: "teal.500",
          color: "white",
          _hover: {
            bg: "teal.600",
          },
        },
        outline: {
          borderColor: "teal.500",
          color: "teal.500",
          _hover: {
            bg: "teal.50",
          },
        },
        link: {
          color: "teal.600",
          _hover: {
            textDecoration: "none",
            color: "teal.500",
          },
        },
      },
    },
    Table: {
      variants: {
        simple: {
          th: {
            borderBottom: "1px",
            borderColor: "gray.200",
            padding: "12px",
            fontWeight: "600",
            bg: "gray.50",
          },
          td: {
            padding: "12px",
            borderBottom: "1px",
            borderColor: "gray.100",
          },
          tr: {
            transition: "background-color 0.2s",
            _hover: {
              bg: "gray.50",
            },
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          borderRadius: "lg",
          boxShadow: "xl",
        },
      },
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: "md",
        },
      },
      variants: {
        outline: {
          field: {
            borderColor: "gray.300",
            _hover: {
              borderColor: "teal.300",
            },
            _focus: {
              borderColor: "teal.500",
              boxShadow: "0 0 0 1px teal.500",
            },
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: "600",
        color: "gray.800",
      },
    },
    Tag: {
      baseStyle: {
        container: {
          borderRadius: "full",
        },
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: "gray.50",
        color: "gray.800",
      },
    },
  },
});

export default theme;
